// PAGE_NAME_BY_ROUTE maps a route pattern to the breadcrumb label shown to
// the right of the site name. More specific entries win over less specific
// ones — order matters. Patterns are matched against the current pathname
// via pageNameForPath().

interface Entry {
  pattern: RegExp;
  label: (params: Record<string, string>) => string;
}

const ENTRIES: Entry[] = [
  { pattern: /^\/setup$/, label: () => 'Setup' },
  { pattern: /^\/sites$/, label: () => 'Sites' },
  { pattern: /^\/alerts$/, label: () => 'Alerts' },
  { pattern: /^\/queue$/, label: () => 'Publish queue' },
  { pattern: /^\/prompts(\/[^/]+)?$/, label: () => 'Prompt Templates' },
  { pattern: /^\/help(\/[^/]+)?$/, label: () => 'Help' },
  { pattern: /^\/settings$/, label: () => 'Settings' },

  { pattern: /^\/sites\/[^/]+\/brainstorm$/, label: () => 'Brainstorm' },
  { pattern: /^\/sites\/[^/]+\/pipeline$/, label: () => 'Pipeline' },
  { pattern: /^\/sites\/[^/]+\/drafts\/[^/]+$/, label: () => 'Draft' },
  { pattern: /^\/sites\/[^/]+\/drafts$/, label: () => 'Drafts' },
  { pattern: /^\/sites\/[^/]+\/articles\/[^/]+$/, label: () => 'Article' },
  { pattern: /^\/sites\/[^/]+\/articles$/, label: () => 'Articles' },
  { pattern: /^\/sites\/[^/]+\/queue$/, label: () => 'Publish queue' },
  { pattern: /^\/sites\/[^/]+\/content-graph$/, label: () => 'Content Graph' },
  { pattern: /^\/sites\/[^/]+\/analytics$/, label: () => 'Analytics' },
  { pattern: /^\/sites\/[^/]+\/alerts$/, label: () => 'Alerts' },
  { pattern: /^\/sites\/[^/]+\/prompts(\/[^/]+)?$/, label: () => 'Prompts' },
  { pattern: /^\/sites\/[^/]+$/, label: () => 'Hub' },
];

export function pageNameForPath(pathname: string): string {
  for (const e of ENTRIES) {
    if (e.pattern.test(pathname)) return e.label({});
  }
  return 'Dashboard';
}
